import React, { FunctionComponent } from "react";
import { DropdownItem } from "reactstrap";
import { NavLink } from "react-router-dom";
import { HeaderChild } from "interfaces/header/HeaderInterfaces";

type Props = { child: HeaderChild };

const SubMenuLeafItem: FunctionComponent<Props> = ({ child }) => (
  <DropdownItem className="menu-item dropdown-item d-flex align-items-center justify-content-between p-4 submenu-row">
    {child.link ? (
      <NavLink to={child.link} className="flex-grow-1">
        {child.label}
      </NavLink>
    ) : (
      <span className="flex-grow-1">{child.label}</span>
    )}
    <span className="submenu-caret invisible" aria-hidden />
  </DropdownItem>
);

export default SubMenuLeafItem;
